export const CALENDAR_EVENTS_MONTHLY = '/api/v1/calendar-events/for-parent/monthly';
export const CALENDAR_EVENTS_DAILY = '/api/v1/calendar-events/for-parent/daily';
